export default __webpack_public_path__ + "static/media/property_117.67804f14.png";